const getDefaultState = () => {
  return {
    integrations: {
      googleCalendar: {
        name: "Google Calendar",
        app: "googleCalendar",
        icon: "IconGoogleCalendar",
        iconViewBox: "186 38 76 76",
        connected: false,
        info: "Sync Cofocus with your Google Calendar. Your sessions will show up in your Google Calendar.",
      },
    },
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },

  /**
   * { data } — array of objects representing integrations and their states
   */
  SET_ALL_INTEGRATION_STATES(state, data) {
    for (var i = 0; i < data.length; i++) {
      const integration = data[i];
      const app = integration.app;
      state.integrations[app]["connected"] = integration.connected;
    }
  },

  SET_INTEGRATION_CONNECTED_STATE(state, data) {
    state.integrations[data.integration]["connected"] = data.connected;
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  setAllIntegrationStates({ commit }, data) {
    commit("SET_ALL_INTEGRATION_STATES", data);
  },
  setIntegrationConnectedState({ commit }, data) {
    commit("SET_INTEGRATION_CONNECTED_STATE", data);
  },
};

const integrations = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default integrations;
